// state
const state = {
  loading: false,
}

// mutations
const mutations = {
  changeLoadingFlag(state, flag) {
    state.loading = flag
  },
}

// actions
const actions = {
  callMutation: _.debounce(({ state, commit }, { flag }) => {
    commit('changeLoadingFlag', flag)
  }, 0),
}

// getters
const getters = {
  isLoading(state) {
    return state.loading
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
